import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SclExportService {

  format = 'csv';
  headers = [];

  constructor(private  httpClient: HttpClient) { }

  export(qry, filename, settings, handlebarsHelpers ): Observable<any> {

    const type = this.format;
    filename = filename  + '.' + type;

    if (!this.headers) {
      this.headers = [{title: 'ID', field: 'documentId'}, {title: 'name', field: 'systemHeader.summaryName'}];
    }

    const body = {
        headers: this.headers,
        query: qry,
        fileName: filename,
        type: type,
        size: settings?.size || 'A4',
        layout: settings?.layout || 'landscape',
        fontSize: settings?.fontSize || 10,
        margin: settings?.margin || 25,
        headerFontSize: settings?.headerFontSize || 8,
        columnSpacing: settings?.columnSpacing || 5,
        urlExportMode: settings?.urlExportMode || 'linkObject',
        handlebarsHelpers: handlebarsHelpers || []
      };

    const options = {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      responseType: 'blob' as 'json'
    };

    return this.httpClient.post('/api/searchExport', body, options );
  }

}
